function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M144-192q-20 0-34-14t-14-34q0-20 14-34t34-14h48v-408q0-29.7 21.15-50.85Q234.3-768 264-768h516q15.3 0 25.65 10.29Q816-747.42 816-732.21t-10.35 25.71Q795.3-696 780-696H264v408h168q20 0 34 14t14 34q0 20-14 34t-34 14H144Zm468.28 0q-15.28 0-25.78-10.34-10.5-10.34-10.5-25.63v-359.74q0-15.29 10.34-25.79t25.62-10.5h215.76q15.28 0 25.78 10.34 10.5 10.34 10.5 25.63v359.74q0 15.29-10.34 25.79T828.04-192H612.28Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#5f6368"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/switchDevice.ff64d6c7.svg";
export { SvgComponent as ReactComponent };